// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const OptionContainer = styled.div`
  display: flex;
`;
